import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";

import RelatedSuccess from "components/CreateWizard/Success/RelatedSuccess";

class RelatedSuccessContainer extends React.PureComponent {
  render() {
    return <RelatedSuccess {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSplitColumn: (column) => dispatch(setupReducer.updateSplitColumn(ownProps.id, column)),

  updateRelatedId: (relatedId) =>
    dispatch(runReducer.updateRelatedId(ownProps.originalId ? ownProps.originalId : ownProps.id, relatedId)),

  deleteSplitColumn: (splitId) => dispatch(setupReducer.deleteSplitColumn(ownProps.originalId, splitId)),
  addSplitColumn: () => dispatch(setupReducer.addSplitColumn(ownProps.originalId)),
  editSplitColumn: (splitId, splitColumn, isAdd) =>
    dispatch(setupReducer.editSplitColumn(ownProps.originalId, splitId, splitColumn, isAdd))
});

const mapStateToProps = (state, ownProps) => {
  return {
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    splitColumn: setupReducer.getSplitColumn(state, ownProps.id),
    relatedId: ownProps.originalId ? runReducer.getRelatedId(state, ownProps.originalId) : ownProps.id,
    relatedJobs: runReducer.getRelatedJobs(state, ownProps.originalId ? ownProps.originalId : ownProps.id),
    hasSplit: setupReducer.getHasSplit(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(RelatedSuccessContainer);
